<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: [String, null],
    required: true
  },
  label: {
    type: String,
    default: 'Name of GI Database'
  },
  rules: {
    type: Array as () => Array<(v: string) => boolean | string>,
    default: () => [(v: string) => !!v || 'This field is required']
  }
})
const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <v-text-field
    color="primary"
    :label="props.label"
    :model-value="props.modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    type="text"
    :clearable="true"
    :persistent-placeholder="true"
    :rules="props.rules"
  />
</template>

<style scoped></style>
